import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

export default function AddCargo() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(3);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const [loading, setLoading] = useState("");

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allShipsReg, setallShipsReg] = useState([]);
  const [newShip, setNewShip] = useState(
    JSON.parse(localStorage.getItem("newShip")) || false
  );
  const [prevShipCount, setPrevShipCount] = useState(
    JSON.parse(localStorage.getItem("prevShipCount")) || 0
  );

  useEffect(() => {
    async function fetchData() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res1.data.status === 200) {
          const fetchedShips = res1.data.data.reverse();
          const currentShipCount = fetchedShips.length;

          // Check if a new ship was added AFTER the last seen count
          if (currentShipCount > prevShipCount) {
            setNewShip(true);
            localStorage.setItem("newShip", JSON.stringify(true));
            localStorage.setItem(
              "prevShipCount",
              JSON.stringify(currentShipCount)
            );
          }

          setallShipsReg(fetchedShips);
        }
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();

    // Polling every 5 seconds
    const interval = setInterval(fetchData, 5000);

    return () => clearInterval(interval);
  }, [prevShipCount]); // Only depend on prevShipCount to avoid unnecessary updates

  const handleView = () => {
    setNewShip(false);
    localStorage.setItem("newShip", JSON.stringify(false));
    setPrevShipCount(allShipsReg.length);
    localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
  };

  const [allShips, setallShips] = useState([]);

  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShip`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [CategoryName, setCategoryName] = useState("");
  const [CategoryImage, setCategoryImage] = useState("");
  const [CategoryDescription, setCategoryDescription] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e, id) => {
    e.preventDefault();

    setLoading(true);
    const data = {
      category_name: CategoryName,
      category_image: CategoryImage,
      category_description: CategoryDescription,
    };
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/addCategory`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status === 200) {
        navigate("/admin/viewCategory");
        console.log(response);
        setLoading(false);
        toast.success("Category added Successfully!", {
          autoClose: 1500,
          position: "top-right",
        });
        setCategoryName("");
        setCategoryImage("");
        setCategoryDescription("");
      } else {
        setLoading(false);
        console.log("error1");
        toast.error("Fill the required Fields", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [formType, setFormType] = useState("sale"); // Default to "sale"

  const [vesselType, setvesselType] = useState("");
 
  const [YearBuilt, setYearBuilt] = useState("");
  const [DWT, setDWT] = useState("");

  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  
  const [OpenArea,setOpenArea] = useState('')
  const [TCVC,setTCVC] = useState('')

  

  const [count, setCount] = useState(0);

  const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Limit to 3 images max
    if (files.length + selectedImages.length > 3) {
      toast.error("You can only upload up to 3 images.");
      return;
    }

    const newFiles = files.map((file) => {
      file.preview = URL.createObjectURL(file);
      return file;
    });

    setSelectedImages((prev) => [...prev, ...newFiles]);
  };

  const removeImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  const [generatedCode, setGeneratedCode] = useState("");
          
            const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");
  
  const subCategoryPrefixes = {
    barge: "BRG",
    bulk: "BLK",
    cargo: "CRG",
    container: "CNT",
    fishing: "FIS",
    multipurpose: "MPP",
    passengerferry: "PAX",
    reefer: "REF",
    roro: "ROR",
    tanker: "TNK",
    tugboat: "TUG",
    dredger: "DRG",
    floatingcrane: "FLC",
    landingcraft: "LCT",
    Yacht: "YCT",
    supplyboat: "SUB",
    crewboat: "CRB",
    floatingdock: "FLD",
    others: "OTR"
  };
  
  useEffect(() => { 
    if (vesselType) {
      const normalized = normalize(vesselType);
      const prefix = subCategoryPrefixes[normalized];
      if (prefix) {
        setGeneratedCode(prefix); // ✅ Only set the prefix
      } else {
        setGeneratedCode("");
      }
    }
  }, [vesselType]);

const [CompanyAddress,setCompanyAddress] = useState('');
    const [Company,setCompany] = useState('');
    const [name,setName] = useState('');
    const [Lychan,setLychan] = useState('');
    const [TypeOfCargo,setTypeOfCargo] = useState('')
    const [Tonnage,setTonnage] = useState('')
    const [LoadingPort,setLoadingPort] = useState('')
    const [DischargePort,setDischargePort] = useState('')
    const [ChartererAcc,setChartererAcc] = useState('')
    const [Commission,setCommission] = useState('')
    const userId = localStorage.getItem("userId");
     const token = localStorage.getItem('token')
    

    const handleSubmitCharter = async (e, id) => {
        e.preventDefault();
        setLoading(true);
    
        const formData = new FormData();
    
        // Append text fields
        formData.append("type_of_cargo", TypeOfCargo);
        formData.append("user", userId);
        formData.append("tonnage", Tonnage);
        formData.append("loading_port", LoadingPort);
        formData.append("discharge_port", DischargePort);
        formData.append("lychan", Lychan);
        formData.append("email", Email);
        formData.append("phone", MobileNO);
        formData.append("brief_description", BriefDescription);
        formData.append("name", name);
        formData.append("company_address", CompanyAddress);
        formData.append("company", Company);
        formData.append("charterer_account", ChartererAcc);
        formData.append("commission", Commission);
        
    
        
    
        try {
          const response = await axios.post(
            `${config.base_url}/api/HappyMarineShipping/RegisterLogistics`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            }
          );
          console.log("API Response:", response.data);
          if (response.data.status === 200) {
            navigate("/regShip");
            setLoading(false);
            toast.success("Registered Successfully!", {
              autoClose: 1500,
              position: "top-right",
            });
    
            // Reset form state
            setCount(id);
           
          } else {
            setLoading(false);
            toast.error("Fill the  Fields", {
              autoClose: 1500,
              position: "top-right",
            });
          }
        } catch (err) {
          setLoading(false);
          console.error("Error:", err);
          toast.error("Error", {
            autoClose: 2000,
            position: "top-right",
          });
        }
      };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);


  const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeRegion, setActiveRegion] = useState(null);  // clicked region
      const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
     const [selectedRegion, setSelectedRegion] = useState(null);
          const [selectedCountry, setSelectedCountry] = useState(null);
      
        const regions = {
        Asia: [
          {
            value: "Afghanistan",
            label: "Afghanistan",
            flag: "https://flagcdn.com/w320/af.png",
          },
          {
            value: "Armenia",
            label: "Armenia",
            flag: "https://flagcdn.com/w320/am.png",
          },
          {
            value: "Azerbaijan",
            label: "Azerbaijan",
            flag: "https://flagcdn.com/w320/az.png",
          },
          {
            value: "Bahrain",
            label: "Bahrain",
            flag: "https://flagcdn.com/w320/bh.png",
          },
          {
            value: "Bangladesh",
            label: "Bangladesh",
            flag: "https://flagcdn.com/w320/bd.png",
          },
          {
            value: "Brunei",
            label: "Brunei",
            flag: "https://flagcdn.com/w320/bn.png",
          },
          {
            value: "Cambodia",
            label: "Cambodia",
            flag: "https://flagcdn.com/w320/kh.png",
          },
          {
            value: "China",
            label: "China",
            flag: "https://flagcdn.com/w320/cn.png",
          },
          {
            value: "Cyprus",
            label: "Cyprus",
            flag: "https://flagcdn.com/w320/cy.png",
          },
          {
            value: "Georgia",
            label: "Georgia",
            flag: "https://flagcdn.com/w320/ge.png",
          },
          {
            value: "India",
            label: "India",
            flag: "https://flagcdn.com/w320/in.png",
          },
          {
            value: "Indonesia",
            label: "Indonesia",
            flag: "https://flagcdn.com/w320/id.png",
          },
          { value: "Iran", label: "Iran", flag: "https://flagcdn.com/w320/ir.png" },
          { value: "Iraq", label: "Iraq", flag: "https://flagcdn.com/w320/iq.png" },
          {
            value: "Israel",
            label: "Israel",
            flag: "https://flagcdn.com/w320/il.png",
          },
          {
            value: "Japan",
            label: "Japan",
            flag: "https://flagcdn.com/w320/jp.png",
          },
          {
            value: "Jordan",
            label: "Jordan",
            flag: "https://flagcdn.com/w320/jo.png",
          },
          {
            value: "Kazakhstan",
            label: "Kazakhstan",
            flag: "https://flagcdn.com/w320/kz.png",
          },
          {
            value: "Kuwait",
            label: "Kuwait",
            flag: "https://flagcdn.com/w320/kw.png",
          },
          {
            value: "Kyrgyzstan",
            label: "Kyrgyzstan",
            flag: "https://flagcdn.com/w320/kg.png",
          },
          { value: "Laos", label: "Laos", flag: "https://flagcdn.com/w320/la.png" },
          {
            value: "Lebanon",
            label: "Lebanon",
            flag: "https://flagcdn.com/w320/lb.png",
          },
          {
            value: "Malaysia",
            label: "Malaysia",
            flag: "https://flagcdn.com/w320/my.png",
          },
          {
            value: "Maldives",
            label: "Maldives",
            flag: "https://flagcdn.com/w320/mv.png",
          },
          {
            value: "Mongolia",
            label: "Mongolia",
            flag: "https://flagcdn.com/w320/mn.png",
          },
          {
            value: "Myanmar",
            label: "Myanmar",
            flag: "https://flagcdn.com/w320/mm.png",
          },
          {
            value: "Nepal",
            label: "Nepal",
            flag: "https://flagcdn.com/w320/np.png",
          },
          {
            value: "North Korea",
            label: "North Korea",
            flag: "https://flagcdn.com/w320/kp.png",
          },
          { value: "Oman", label: "Oman", flag: "https://flagcdn.com/w320/om.png" },
          {
            value: "Pakistan",
            label: "Pakistan",
            flag: "https://flagcdn.com/w320/pk.png",
          },
          {
            value: "Palestine",
            label: "Palestine",
            flag: "https://flagcdn.com/w320/ps.png",
          },
          {
            value: "Philippines",
            label: "Philippines",
            flag: "https://flagcdn.com/w320/ph.png",
          },
          {
            value: "Qatar",
            label: "Qatar",
            flag: "https://flagcdn.com/w320/qa.png",
          },
          {
            value: "Russia",
            label: "Russia",
            flag: "https://flagcdn.com/w320/ru.png",
          },
          {
            value: "Saudi Arabia",
            label: "Saudi Arabia",
            flag: "https://flagcdn.com/w320/sa.png",
          },
          {
            value: "Singapore",
            label: "Singapore",
            flag: "https://flagcdn.com/w320/sg.png",
          },
          {
            value: "Korea",
            label: "Korea",
            flag: "https://flagcdn.com/w320/kr.png",
          },
          {
            value: "Sri Lanka",
            label: "Sri Lanka",
            flag: "https://flagcdn.com/w320/lk.png",
          },
          {
            value: "Syria",
            label: "Syria",
            flag: "https://flagcdn.com/w320/sy.png",
          },
          {
            value: "Taiwan",
            label: "Taiwan",
            flag: "https://flagcdn.com/w320/tw.png",
          },
          {
            value: "Tajikistan",
            label: "Tajikistan",
            flag: "https://flagcdn.com/w320/tj.png",
          },
          {
            value: "Thailand",
            label: "Thailand",
            flag: "https://flagcdn.com/w320/th.png",
          },
          {
            value: "Timor-Leste",
            label: "Timor-Leste",
            flag: "https://flagcdn.com/w320/tl.png",
          },
          {
            value: "Turkey",
            label: "Turkey",
            flag: "https://flagcdn.com/w320/tr.png",
          },
          {
            value: "Turkmenistan",
            label: "Turkmenistan",
            flag: "https://flagcdn.com/w320/tm.png",
          },
          {
            value: "United Arab Emirates",
            label: "United Arab Emirates",
            flag: "https://flagcdn.com/w320/ae.png",
          },
          {
            value: "Uzbekistan",
            label: "Uzbekistan",
            flag: "https://flagcdn.com/w320/uz.png",
          },
          {
            value: "Vietnam",
            label: "Vietnam",
            flag: "https://flagcdn.com/w320/vn.png",
          },
          {
            value: "Yemen",
            label: "Yemen",
            flag: "https://flagcdn.com/w320/ye.png",
          },
        ],
    
        Africa: [
          {
            value: "Algeria",
            label: "Algeria",
            flag: "https://flagcdn.com/w320/dz.png",
          },
          {
            value: "Angola",
            label: "Angola",
            flag: "https://flagcdn.com/w320/ao.png",
          },
          {
            value: "Benin",
            label: "Benin",
            flag: "https://flagcdn.com/w320/bj.png",
          },
          {
            value: "Botswana",
            label: "Botswana",
            flag: "https://flagcdn.com/w320/bw.png",
          },
          {
            value: "Burkina Faso",
            label: "Burkina Faso",
            flag: "https://flagcdn.com/w320/bf.png",
          },
          {
            value: "Burundi",
            label: "Burundi",
            flag: "https://flagcdn.com/w320/bi.png",
          },
          {
            value: "Cape Verde",
            label: "Cape Verde",
            flag: "https://flagcdn.com/w320/cv.png",
          },
          {
            value: "Cameroon",
            label: "Cameroon",
            flag: "https://flagcdn.com/w320/cm.png",
          },
          {
            value: "Central African Republic",
            label: "Central African Republic",
            flag: "https://flagcdn.com/w320/cf.png",
          },
          { value: "Chad", label: "Chad", flag: "https://flagcdn.com/w320/td.png" },
          {
            value: "Comoros",
            label: "Comoros",
            flag: "https://flagcdn.com/w320/km.png",
          },
          {
            value: "Congo, Democratic Republic of the",
            label: "Congo, Democratic Republic of the",
            flag: "https://flagcdn.com/w320/cd.png",
          },
          {
            value: "Congo, Republic of the",
            label: "Congo, Republic of the",
            flag: "https://flagcdn.com/w320/cg.png",
          },
          {
            value: "Ivory Coast",
            label: "Ivory Coast",
            flag: "https://flagcdn.com/w320/ci.png",
          },
          {
            value: "Djibouti",
            label: "Djibouti",
            flag: "https://flagcdn.com/w320/dj.png",
          },
          {
            value: "Egypt",
            label: "Egypt",
            flag: "https://flagcdn.com/w320/eg.png",
          },
          {
            value: "Equatorial Guinea",
            label: "Equatorial Guinea",
            flag: "https://flagcdn.com/w320/gq.png",
          },
          {
            value: "Eritrea",
            label: "Eritrea",
            flag: "https://flagcdn.com/w320/er.png",
          },
          {
            value: "Ethiopia",
            label: "Ethiopia",
            flag: "https://flagcdn.com/w320/et.png",
          },
          {
            value: "Gabon",
            label: "Gabon",
            flag: "https://flagcdn.com/w320/ga.png",
          },
          {
            value: "Gambia",
            label: "Gambia",
            flag: "https://flagcdn.com/w320/gm.png",
          },
          {
            value: "Ghana",
            label: "Ghana",
            flag: "https://flagcdn.com/w320/gh.png",
          },
          {
            value: "Guinea",
            label: "Guinea",
            flag: "https://flagcdn.com/w320/gn.png",
          },
          {
            value: "Guinea-Bissau",
            label: "Guinea-Bissau",
            flag: "https://flagcdn.com/w320/gw.png",
          },
          {
            value: "Kenya",
            label: "Kenya",
            flag: "https://flagcdn.com/w320/ke.png",
          },
          {
            value: "Lesotho",
            label: "Lesotho",
            flag: "https://flagcdn.com/w320/ls.png",
          },
          {
            value: "Liberia",
            label: "Liberia",
            flag: "https://flagcdn.com/w320/lr.png",
          },
          {
            value: "Libya",
            label: "Libya",
            flag: "https://flagcdn.com/w320/ly.png",
          },
          {
            value: "Madagascar",
            label: "Madagascar",
            flag: "https://flagcdn.com/w320/mg.png",
          },
          {
            value: "Malawi",
            label: "Malawi",
            flag: "https://flagcdn.com/w320/mw.png",
          },
          { value: "Mali", label: "Mali", flag: "https://flagcdn.com/w320/ml.png" },
          {
            value: "Mauritania",
            label: "Mauritania",
            flag: "https://flagcdn.com/w320/mr.png",
          },
          {
            value: "Mauritius",
            label: "Mauritius",
            flag: "https://flagcdn.com/w320/mu.png",
          },
          {
            value: "Morocco",
            label: "Morocco",
            flag: "https://flagcdn.com/w320/ma.png",
          },
          {
            value: "Mozambique",
            label: "Mozambique",
            flag: "https://flagcdn.com/w320/mz.png",
          },
          {
            value: "Namibia",
            label: "Namibia",
            flag: "https://flagcdn.com/w320/na.png",
          },
          {
            value: "Niger",
            label: "Niger",
            flag: "https://flagcdn.com/w320/ne.png",
          },
          {
            value: "Nigeria",
            label: "Nigeria",
            flag: "https://flagcdn.com/w320/ng.png",
          },
          {
            value: "Rwanda",
            label: "Rwanda",
            flag: "https://flagcdn.com/w320/rw.png",
          },
          {
            value: "Sao Tome and Principe",
            label: "Sao Tome and Principe",
            flag: "https://flagcdn.com/w320/st.png",
          },
          {
            value: "Senegal",
            label: "Senegal",
            flag: "https://flagcdn.com/w320/sn.png",
          },
          {
            value: "Seychelles",
            label: "Seychelles",
            flag: "https://flagcdn.com/w320/sc.png",
          },
          {
            value: "Sierra Leone",
            label: "Sierra Leone",
            flag: "https://flagcdn.com/w320/sl.png",
          },
          {
            value: "Somalia",
            label: "Somalia",
            flag: "https://flagcdn.com/w320/so.png",
          },
          {
            value: "South Africa",
            label: "South Africa",
            flag: "https://flagcdn.com/w320/za.png",
          },
          {
            value: "Sudan",
            label: "Sudan",
            flag: "https://flagcdn.com/w320/sd.png",
          },
          {
            value: "Tanzania",
            label: "Tanzania",
            flag: "https://flagcdn.com/w320/tz.png",
          },
          { value: "Togo", label: "Togo", flag: "https://flagcdn.com/w320/tg.png" },
          {
            value: "Tunisia",
            label: "Tunisia",
            flag: "https://flagcdn.com/w320/tn.png",
          },
          {
            value: "Uganda",
            label: "Uganda",
            flag: "https://flagcdn.com/w320/ug.png",
          },
          {
            value: "Zambia",
            label: "Zambia",
            flag: "https://flagcdn.com/w320/zm.png",
          },
          {
            value: "Zimbabwe",
            label: "Zimbabwe",
            flag: "https://flagcdn.com/w320/zw.png",
          },
        ],
        Europe: [
          {
            value: "Albania",
            label: "Albania",
            flag: "https://flagcdn.com/w320/al.png",
          },
          {
            value: "Andorra",
            label: "Andorra",
            flag: "https://flagcdn.com/w320/ad.png",
          },
          {
            value: "Armenia",
            label: "Armenia",
            flag: "https://flagcdn.com/w320/am.png",
          },
          {
            value: "Austria",
            label: "Austria",
            flag: "https://flagcdn.com/w320/at.png",
          },
          {
            value: "Azerbaijan",
            label: "Azerbaijan",
            flag: "https://flagcdn.com/w320/az.png",
          },
          {
            value: "Belarus",
            label: "Belarus",
            flag: "https://flagcdn.com/w320/by.png",
          },
          {
            value: "Belgium",
            label: "Belgium",
            flag: "https://flagcdn.com/w320/be.png",
          },
          {
            value: "Bosnia and Herzegovina",
            label: "Bosnia and Herzegovina",
            flag: "https://flagcdn.com/w320/ba.png",
          },
          {
            value: "Bulgaria",
            label: "Bulgaria",
            flag: "https://flagcdn.com/w320/bg.png",
          },
          {
            value: "Croatia",
            label: "Croatia",
            flag: "https://flagcdn.com/w320/hr.png",
          },
          {
            value: "Cyprus",
            label: "Cyprus",
            flag: "https://flagcdn.com/w320/cy.png",
          },
          {
            value: "Czech Republic",
            label: "Czech Republic",
            flag: "https://flagcdn.com/w320/cz.png",
          },
          {
            value: "Denmark",
            label: "Denmark",
            flag: "https://flagcdn.com/w320/dk.png",
          },
          {
            value: "Estonia",
            label: "Estonia",
            flag: "https://flagcdn.com/w320/ee.png",
          },
          {
            value: "Finland",
            label: "Finland",
            flag: "https://flagcdn.com/w320/fi.png",
          },
          {
            value: "France",
            label: "France",
            flag: "https://flagcdn.com/w320/fr.png",
          },
          {
            value: "Georgia",
            label: "Georgia",
            flag: "https://flagcdn.com/w320/ge.png",
          },
          {
            value: "Germany",
            label: "Germany",
            flag: "https://flagcdn.com/w320/de.png",
          },
          {
            value: "Greece",
            label: "Greece",
            flag: "https://flagcdn.com/w320/gr.png",
          },
          {
            value: "Hungary",
            label: "Hungary",
            flag: "https://flagcdn.com/w320/hu.png",
          },
          {
            value: "Iceland",
            label: "Iceland",
            flag: "https://flagcdn.com/w320/is.png",
          },
          {
            value: "Ireland",
            label: "Ireland",
            flag: "https://flagcdn.com/w320/ie.png",
          },
          {
            value: "Italy",
            label: "Italy",
            flag: "https://flagcdn.com/w320/it.png",
          },
          {
            value: "Kazakhstan",
            label: "Kazakhstan",
            flag: "https://flagcdn.com/w320/kz.png",
          },
          {
            value: "Kosovo",
            label: "Kosovo",
            flag: "https://flagcdn.com/w320/xk.png",
          },
          {
            value: "Latvia",
            label: "Latvia",
            flag: "https://flagcdn.com/w320/lv.png",
          },
          {
            value: "Liechtenstein",
            label: "Liechtenstein",
            flag: "https://flagcdn.com/w320/li.png",
          },
          {
            value: "Lithuania",
            label: "Lithuania",
            flag: "https://flagcdn.com/w320/lt.png",
          },
          {
            value: "Luxembourg",
            label: "Luxembourg",
            flag: "https://flagcdn.com/w320/lu.png",
          },
          {
            value: "Malta",
            label: "Malta",
            flag: "https://flagcdn.com/w320/mt.png",
          },
          {
            value: "Moldova",
            label: "Moldova",
            flag: "https://flagcdn.com/w320/md.png",
          },
          {
            value: "Monaco",
            label: "Monaco",
            flag: "https://flagcdn.com/w320/mc.png",
          },
          {
            value: "Montenegro",
            label: "Montenegro",
            flag: "https://flagcdn.com/w320/me.png",
          },
          {
            value: "Netherlands",
            label: "Netherlands",
            flag: "https://flagcdn.com/w320/nl.png",
          },
          {
            value: "North Macedonia",
            label: "North Macedonia",
            flag: "https://flagcdn.com/w320/mk.png",
          },
          {
            value: "Norway",
            label: "Norway",
            flag: "https://flagcdn.com/w320/no.png",
          },
          {
            value: "Poland",
            label: "Poland",
            flag: "https://flagcdn.com/w320/pl.png",
          },
          {
            value: "Portugal",
            label: "Portugal",
            flag: "https://flagcdn.com/w320/pt.png",
          },
          {
            value: "Romania",
            label: "Romania",
            flag: "https://flagcdn.com/w320/ro.png",
          },
          {
            value: "Russia",
            label: "Russia",
            flag: "https://flagcdn.com/w320/ru.png",
          },
          {
            value: "San Marino",
            label: "San Marino",
            flag: "https://flagcdn.com/w320/sm.png",
          },
          {
            value: "Serbia",
            label: "Serbia",
            flag: "https://flagcdn.com/w320/rs.png",
          },
          {
            value: "Slovakia",
            label: "Slovakia",
            flag: "https://flagcdn.com/w320/sk.png",
          },
          {
            value: "Slovenia",
            label: "Slovenia",
            flag: "https://flagcdn.com/w320/si.png",
          },
          {
            value: "Spain",
            label: "Spain",
            flag: "https://flagcdn.com/w320/es.png",
          },
          {
            value: "Sweden",
            label: "Sweden",
            flag: "https://flagcdn.com/w320/se.png",
          },
          {
            value: "Switzerland",
            label: "Switzerland",
            flag: "https://flagcdn.com/w320/ch.png",
          },
          {
            value: "Turkey",
            label: "Turkey",
            flag: "https://flagcdn.com/w320/tr.png",
          },
          {
            value: "Ukraine",
            label: "Ukraine",
            flag: "https://flagcdn.com/w320/ua.png",
          },
          {
            value: "United Kingdom",
            label: "United Kingdom",
            flag: "https://flagcdn.com/w320/gb.png",
          },
          {
            value: "Vatican City",
            label: "Vatican City",
            flag: "https://flagcdn.com/w320/va.png",
          },
        ],
        America: [
          {
            value: "Antigua and Barbuda",
            label: "Antigua and Barbuda",
            flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Antigua_and_Barbuda.svg/1200px-Flag_of_Antigua_and_Barbuda.svg.png",
          },
          {
            value: "Argentina",
            label: "Argentina",
            flag: "https://flagcdn.com/w320/ar.png",
          },
          {
            value: "Aruba",
            label: "Aruba",
            flag: "https://flagcdn.com/w320/aw.png",
          },
          {
            value: "Bahamas",
            label: "Bahamas",
            flag: "https://flagcdn.com/w320/bs.png",
          },
          {
            value: "Barbados",
            label: "Barbados",
            flag: "https://flagcdn.com/w320/bb.png",
          },
          {
            value: "Belize",
            label: "Belize",
            flag: "https://flagcdn.com/w320/bz.png",
          },
          {
            value: "Bermuda",
            label: "Bermuda",
            flag: "https://flagcdn.com/w320/bm.png",
          },
          {
            value: "Bolivia",
            label: "Bolivia",
            flag: "https://flagcdn.com/w320/bo.png",
          },
          {
            value: "Brazil",
            label: "Brazil",
            flag: "https://flagcdn.com/w320/br.png",
          },
          {
            value: "British Virgin Islands",
            label: "British Virgin Islands",
            flag: "https://flagcdn.com/w320/vg.png",
          },
          {
            value: "Canada",
            label: "Canada",
            flag: "https://flagcdn.com/w320/ca.png",
          },
          {
            value: "Cayman Islands",
            label: "Cayman Islands",
            flag: "https://flagcdn.com/w320/ky.png",
          },
          {
            value: "Chile",
            label: "Chile",
            flag: "https://flagcdn.com/w320/cl.png",
          },
          {
            value: "Colombia",
            label: "Colombia",
            flag: "https://flagcdn.com/w320/co.png",
          },
          {
            value: "Costa Rica",
            label: "Costa Rica",
            flag: "https://flagcdn.com/w320/cr.png",
          },
          {
            value: "Cuba",
            label: "Cuba",
            flag: "https://flagcdn.com/w320/cu.png",
          },
          {
            value: "Curacao",
            label: "Curacao",
            flag: "https://flagcdn.com/w320/cw.png",
          },
          {
            value: "Dominica",
            label: "Dominica",
            flag: "https://flagcdn.com/w320/dm.png",
          },
          {
            value: "Dominican Republic",
            label: "Dominican Republic",
            flag: "https://flagcdn.com/w320/do.png",
          },
          {
            value: "Ecuador",
            label: "Ecuador",
            flag: "https://flagcdn.com/w320/ec.png",
          },
          {
            value: "El Salvador",
            label: "El Salvador",
            flag: "https://flagcdn.com/w320/sv.png",
          },
          {
            value: "Grenada",
            label: "Grenada",
            flag: "https://flagcdn.com/w320/gd.png",
          },
          {
            value: "Guatemala",
            label: "Guatemala",
            flag: "https://flagcdn.com/w320/gt.png",
          },
          {
            value: "Guyana",
            label: "Guyana",
            flag: "https://flagcdn.com/w320/gy.png",
          },
          {
            value: "Haiti",
            label: "Haiti",
            flag: "https://flagcdn.com/w320/ht.png",
          },
          {
            value: "Honduras",
            label: "Honduras",
            flag: "https://flagcdn.com/w320/hn.png",
          },
          {
            value: "Jamaica",
            label: "Jamaica",
            flag: "https://flagcdn.com/w320/jm.png",
          },
          {
            value: "Mexico",
            label: "Mexico",
            flag: "https://flagcdn.com/w320/mx.png",
          },
          {
            value: "Nicaragua",
            label: "Nicaragua",
            flag: "https://flagcdn.com/w320/ni.png",
          },
          {
            value: "Panama",
            label: "Panama",
            flag: "https://flagcdn.com/w320/pa.png",
          },
          {
            value: "Paraguay",
            label: "Paraguay",
            flag: "https://flagcdn.com/w320/py.png",
          },
          {
            value: "Peru",
            label: "Peru",
            flag: "https://flagcdn.com/w320/pe.png",
          },
          {
            value: "Puerto Rico",
            label: "Puerto Rico",
            flag: "https://flagcdn.com/w320/pr.png",
          },
          {
            value: "Saint Kitts and Nevis",
            label: "Saint Kitts and Nevis",
            flag: "https://flagcdn.com/w320/kn.png",
          },
          {
            value: "Saint Lucia",
            label: "Saint Lucia",
            flag: "https://flagcdn.com/w320/lc.png",
          },
          {
            value: "Saint Martin (French part)",
            label: "Saint Martin (French part)",
            flag: "https://flagcdn.com/w320/sx.png",
          },
          {
            value: "Saint Vincent and the Grenadines",
            label: "Saint Vincent and the Grenadines",
            flag: "https://flagcdn.com/w320/vc.png",
          },
          {
            value: "Sint Maarten (Dutch part)",
            label: "Sint Maarten (Dutch part)",
            flag: "https://flagcdn.com/w320/sx.png",
          },
          {
            value: "Suriname",
            label: "Suriname",
            flag: "https://flagcdn.com/w320/sr.png",
          },
          {
            value: "Trinidad and Tobago",
            label: "Trinidad and Tobago",
            flag: "https://flagcdn.com/w320/tt.png",
          },
          {
            value: "Turks and Caicos Islands",
            label: "Turks and Caicos Islands",
            flag: "https://flagcdn.com/w320/tc.png",
          },
          {
            value: "United States",
            label: "United States",
            flag: "https://flagcdn.com/w320/us.png",
          },
          {
            value: "United States Virgin Islands",
            label: "United States Virgin Islands",
            flag: "https://flagcdn.com/w320/vi.png",
          },
          {
            value: "Uruguay",
            label: "Uruguay",
            flag: "https://flagcdn.com/w320/uy.png",
          },
          {
            value: "Venezuela",
            label: "Venezuela",
            flag: "https://flagcdn.com/w320/ve.png",
          },
        ],
        Continental: [
          {
            value: "American Samoa",
            label: "American Samoa",
            flag: "https://flagcdn.com/w320/as.png",
          },
          {
            value: "Australia",
            label: "Australia",
            flag: "https://flagcdn.com/w320/au.png",
          },
          {
            value: "Christmas Island",
            label: "Christmas Island",
            flag: "https://flagcdn.com/w320/cx.png",
          },
          {
            value: "Cook Islands",
            label: "Cook Islands",
            flag: "https://flagcdn.com/w320/ck.png",
          },
          {
            value: "Fiji",
            label: "Fiji",
            flag: "https://flagcdn.com/w320/fj.png",
          },
          {
            value: "French Polynesia",
            label: "French Polynesia",
            flag: "https://flagcdn.com/w320/pf.png",
          },
          {
            value: "Guam",
            label: "Guam",
            flag: "https://flagcdn.com/w320/gu.png",
          },
          {
            value: "Kiribati",
            label: "Kiribati",
            flag: "https://flagcdn.com/w320/ki.png",
          },
          {
            value: "Marshall Islands",
            label: "Marshall Islands",
            flag: "https://flagcdn.com/w320/mh.png",
          },
          {
            value: "Micronesia",
            label: "Micronesia",
            flag: "https://flagcdn.com/w320/fm.png",
          },
          {
            value: "Nauru",
            label: "Nauru",
            flag: "https://flagcdn.com/w320/nr.png",
          },
          {
            value: "New Caledonia",
            label: "New Caledonia",
            flag: "https://flagcdn.com/w320/nc.png",
          },
          {
            value: "New Zealand",
            label: "New Zealand",
            flag: "https://flagcdn.com/w320/nz.png",
          },
          {
            value: "Niue",
            label: "Niue",
            flag: "https://flagcdn.com/w320/nu.png",
          },
          {
            value: "Norfolk Island",
            label: "Norfolk Island",
            flag: "https://flagcdn.com/w320/nf.png",
          },
          {
            value: "Northern Mariana Islands",
            label: "Northern Mariana Islands",
            flag: "https://flagcdn.com/w320/mp.png",
          },
          {
            value: "Palau",
            label: "Palau",
            flag: "https://flagcdn.com/w320/pw.png",
          },
          {
            value: "Papua New Guinea",
            label: "Papua New Guinea",
            flag: "https://flagcdn.com/w320/pg.png",
          },
          {
            value: "Pitcairn Islands",
            label: "Pitcairn Islands",
            flag: "https://flagcdn.com/w320/pn.png",
          },
          {
            value: "Samoa",
            label: "Samoa",
            flag: "https://flagcdn.com/w320/ws.png",
          },
          {
            value: "Solomon Islands",
            label: "Solomon Islands",
            flag: "https://flagcdn.com/w320/sb.png",
          },
          {
            value: "Tonga",
            label: "Tonga",
            flag: "https://flagcdn.com/w320/to.png",
          },
          {
            value: "Tuvalu",
            label: "Tuvalu",
            flag: "https://flagcdn.com/w320/tv.png",
          },
          {
            value: "Vanuatu",
            label: "Vanuatu",
            flag: "https://flagcdn.com/w320/vu.png",
          },
          {
            value: "Wallis and Futuna",
            label: "Wallis and Futuna",
            flag: "https://flagcdn.com/w320/wf.png",
          },
        ],
      };
    
      useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, [pathname]);
    
      const allCountries = Object.entries(regions).flatMap(([region, countries]) =>
          countries.map((country) => ({
            ...country,
            region,
          }))
        );
    
    
      // Close dropdown on outside click
     useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
            setActiveRegion(null);
            setHoveredRegion(null);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
          

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}

          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={"/admin/profile"}>Profile</Link>
                  </li>
                  <li className="px-3 py-1 hover:text-[#00c292]">
                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
          }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className="px-4 py-2 text-lg   flex items-center">
              <i className="fa-solid fa-gauge mr-3"></i>
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>

            {isSidebarOpen && (
              <div className="px-5 mt-2 w-[75%]">
                <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                  Registrations
                </h1>
              </div>
            )}

            {/* Ship For Sale Dropdown */}
            <li className="px-2   text-lg  flex flex-col  relative">
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  border-l-4 border-[#00c292]   text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Open Cargo </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full text-[#00c292]">
                      <Link>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link> <Link to='/admin/viewCargo' >View Cargo</Link></Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full text-[#00c292]">
                      <Link>Add  Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link> <Link to='/admin/viewCargo' >View Cargo</Link></Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Supply Equipments </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {isSidebarOpen && (
              <div className="px-5 mt-2 w-[75%]">
                <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                  Approvals
                </h1>
              </div>
            )}
            {isSidebarOpen && (
              <ul className="px-2  text-lg flex flex-col relative group">
                <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                  <Link
                    to="/admin/shipforsale"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Ships For Sale
                  </Link>
                  {newShip && (
                    <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                      New
                    </span>
                  )}
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                    to="/admin/shipforCharterApp"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Ship For Charter
                  </Link>
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                  to='/admin/LogisticsAppr'
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Open Cargo
                  </Link>
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                    to="/admin/shipforEqApp"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Supply Equipments
                  </Link>
                </li>
              </ul>
            )}

            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-gear"></i>
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to={"/admin"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/admin"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* mobile screen sidebar */}

        <div
          className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
            isMobile
              ? isSidebarOpen
                ? "w-full translate-x-0" // Open in full width on mobile
                : "-translate-x-full w-0" // Hide sidebar on mobile
              : isSidebarOpen
              ? "w-60 translate-x-0" // Open normally on desktop
              : "w-0" // Hide sidebar on desktop
          }`}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className={`px-4 py-2 text-lg    flex items-center`}>
              {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>

            {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}

            {/* Ship For Sale Dropdown */}
            <li className={`px-2  text-lg  flex flex-col  relative`}>
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg  flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-[#00c292] border-l-4 border-[#00c292] text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Logistics</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full text-[#00c292]">
                      <Link>Add  Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link> <Link to='/admin/viewCargo' >View Cargo</Link></Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full text-[#00c292]">
                      <Link>Add  Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link> <Link to='/admin/viewCargo' >View Cargo</Link></Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Supply Equipments</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg flex flex-col relative group">
              {/* Clickable Div */}
              {isSidebarOpen && (
                <div className="px-5  w-[50%]">
                  <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                    Approvals
                  </h1>
                </div>
              )}

              {isSidebarOpen && (
                <ul
                  className="px-2 py-2  text-lg flex gap-3
                                                                               flex-col relative group"
                >
                  <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                    <Link
                      to="/admin/shipforsale"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Ships For Sale
                    </Link>
                    {newShip && (
                      <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                        New
                      </span>
                    )}
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                      to="/admin/shipforCharterApp"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Ship For Charter
                    </Link>
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                    to='/admin/LogisticsAppr'
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Open Cargo
                    </Link>
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                      to="/admin/shipforEqApp"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Supply Equipments
                    </Link>
                  </li>
                </ul>
              )}

              {/* Click Dropdown (For open sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 5
                      ? "max-h-48 opacity-100 "
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforsale"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Ships For Sale
                      </Link>
                      {newShip && (
                        <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                          New
                        </span>
                      )}
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforCharterApp"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Ship For Charter
                      </Link>
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                      to='/admin/LogisticsAppr'
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Open Cargo
                      </Link>
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforEqApp"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Supply Equipments
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Settings Dropdown */}
            <li className="px-3  text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/admin"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/admin"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div className="flex-1 py-4 overflow-y-auto">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
            <div className="flex justify-between items-center">
              <h1>Add Category </h1>
              <div className="flex text-sm gap-2">
                <Link to={'/adminHome'}>Home</Link> <span>/</span>
                <p className="text-[#00c292]">Add Cargo</p>
              </div>
            </div>
          </div>
          <div className="w-full py-5 px-4">
             <form className="bg-white mt-2 rounded w-full">
  <div className="p-5">
    <h1 className="text-black font-bold text-xl">Register Cargo</h1>
  </div>
  <hr className="text-gray-100 w-full" />

  {/* Type of Cargo */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="TypeOfCargo" className="font-semibold w-[170px] xm:w-full">
        Type Of Cargo
      </label>
      <input
        value={TypeOfCargo}
        onChange={(e) => setTypeOfCargo(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="TypeOfCargo"
        placeholder="Enter Type Of Cargo"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Tonnage" className="font-semibold w-[170px] xm:w-full">
        Tonnage
      </label>
      <input
        value={Tonnage}
        onChange={(e) => setTonnage(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Tonnage"
        placeholder="Enter Tonnage"
      />
    </div>
  </div>

  {/* Loading & Discharge Port */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="LoadingPort" className="font-semibold w-[170px] xm:w-full">
        Loading Port
      </label>
      <input
        value={LoadingPort}
        onChange={(e) => setLoadingPort(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="LoadingPort"
        placeholder="Enter Loading Port"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="DischargePort" className="font-semibold w-[170px] xm:w-full">
        Discharge Port
      </label>
      <input
        value={DischargePort}
        onChange={(e) => setDischargePort(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="DischargePort"
        placeholder="Enter Discharge Port"
      />
    </div>
  </div>

  {/* Lychan & Charterer */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Lychan" className="font-semibold w-[170px] xm:w-full">
        Lychan
      </label>
      <input
        value={Lychan}
        onChange={(e) => setLychan(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Lychan"
        placeholder="Enter Lychan"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="ChartererAcc" className="font-semibold w-[170px] xm:w-full">
        Charterer Account/Shipper
      </label>
      <input
        value={ChartererAcc}
        onChange={(e) => setChartererAcc(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="ChartererAcc"
        placeholder="Enter Charterer Account/Shipper"
      />
    </div>
  </div>

  {/* Commission */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Commission" className="font-semibold w-[170px] xm:w-full">
        Commission
      </label>
      <input
        value={Commission}
        onChange={(e) => setCommission(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Commission"
        placeholder="Enter Commission"
      />
    </div>
  </div>

  {/* Contact Information */}
  <div className="p-5">
    <h1 className="font-bold text-xl">Contact Information</h1>
    <hr className="border border-gray-200 w-full" />
  </div>

  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Name" className="font-semibold w-[170px] xm:w-full">
        Name of the Owner
      </label>
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Name"
        placeholder="Enter Owner Name"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Company" className="font-semibold w-[170px] xm:w-full">
        Company of the Owner
      </label>
      <input
        value={Company}
        onChange={(e) => setCompany(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Company"
        placeholder="Enter Company Name"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="CompanyAddress" className="font-semibold w-[170px] xm:w-full">
        Company Address
      </label>
      <input
        value={CompanyAddress}
        onChange={(e) => setCompanyAddress(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="CompanyAddress"
        placeholder="Enter Company Address"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Email" className="font-semibold w-[170px] xm:w-full">
        Email
      </label>
      <input
        value={Email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Email"
        placeholder="Enter Email"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="MobileNo" className="font-semibold w-[170px] xm:w-full">
        Mobile No
      </label>
      <input
        value={MobileNO}
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="MobileNo"
        placeholder="Enter Mobile Number"
      />
    </div>
  </div>

  {/* Additional Info */}
  <div className="p-5 flex flex-col gap-3">
    <label htmlFor="BriefDescription" className="font-semibold">
      Additional Informations
    </label>
    <textarea
      value={BriefDescription}
      onChange={(e) => setBriefDescription(e.target.value)}
      className="w-full rounded border border-gray-400 p-2 text-gray-500"
      id="BriefDescription"
      rows={5}
      placeholder="More info..."
    />
  </div>

  <hr className="text-gray-500 w-full" />
  <div className="p-4">
    <button
      type="submit"
      onClick={(e) => handleSubmitCharter(e)}
      className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
    >
      Submit
    </button>
  </div>
</form>
          </div>
        </div>
      </div>
    </div>
  );
}
